
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookies-list",
      function () {
        return require("private-next-pages/cookies-list.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cookies-list"])
      });
    }
  